import { useEffect, useState } from "react";
import { useWidgetDndContextData } from "src/context/WidgetDndContext";
import Accordian from "./Component/Accordian";
import RenderColourFilters from "./Component/RenderColourFilters";
import RenderSizeFilters from "./Component/RenderSizeFilters";
import CustomFilter from "./Component/CustomFilter";
import { COLOUR, SIZE } from "./constant";
import { SortAndFilterContent } from "./SortAndFilterContent";
import { FILTER_COUNTER_OPTIONS } from "src/utils/constants";
import { filtersCounter, saveFilteredOptions } from '@/redux/actions';
import { useDispatch, useSelector } from "react-redux";
import { setMB7SortAndFilterConfig } from "../../MiddleBody/MiddleBody7/utils";
import { isMobileDevice } from "src/components/WidgetMaker/WidgetDnD/isMobileDevice";
import { COMMON_LAYOUT_TYPE } from "../ListPresentation/components/Testimonials/Constants";
import { Drawer } from "node_modules/@mui/material/index";
import { getFilterTitleStyle, getFontWeightStyle } from "./utils";
import { crossSvg } from "./svg/svgList";
import { cloneDeep } from "lodash";
import { buttonStyle } from "src/utils/globalStyleHelper";

const SortAndFilter = (props: any) => {
  const { filterOption, showFilters, hideFilter, isViewMore, setIsViewMore, selectedFilterInfo, setSelectedFilterInfo} = props
  const [selectedElement, setSelectedElement] = useState('');
  const [updatedFilterOption, setUpdatedFilterOption] = useState(filterOption);
  const dispatch = useDispatch();
  const { headerHeight } = useSelector(
    (state: any) => ({
      headerHeight: state.commonReducer?.headerRef?.current?.clientHeight ?? 0,
    })
  );
  const isMobile = isMobileDevice();
  const filterScrollheight = headerHeight + 220;
  const {
    widgetContextState: { pageStyle, globalStyle },
  } = useWidgetDndContextData();
  const desktopLayout = pageStyle?.sortAndFilter?.layout_desktop;
  const isLayout3 = isMobile ? false : desktopLayout === COMMON_LAYOUT_TYPE.THREE;
  const isLayout2 = isMobile ? false : desktopLayout === COMMON_LAYOUT_TYPE.TWO;

  function handleElementClick(id: string) {
    setSelectedElement(id);
  }
  const globalRadius = buttonStyle(globalStyle, 6)

  useEffect(() => {
    if (filterOption?.length) {
      if (isLayout2) {
        setUpdatedFilterOption(filterOption?.slice(0, 5));
      }
      else {
        setUpdatedFilterOption(filterOption)
      }
    }
  }, [filterOption])


  function showClearAll() {
    const updateSelectedFilter = { ...selectedFilterInfo };
    let showClearAllOption = false
    Object.keys(updateSelectedFilter)?.map((headingKey) => {
      if (updateSelectedFilter[headingKey]?.length) {
        showClearAllOption = true
      }
    })
    return showClearAllOption
  }

  function getFilterStyle() {
    const { title_color = '', title_thickness = '' } = pageStyle?.sortAndFilter || {};
    return {
      color: title_color,
      fontWeight: getFontWeightStyle(title_thickness)
    }
  }

  function handleViewMoreClick() {
    if (isViewMore) {
      setUpdatedFilterOption(filterOption?.slice(0, 5));
    }
    else {
      setUpdatedFilterOption(filterOption);
    }
    setIsViewMore(prev => !prev)
  }


  function removeSelectedFilter(filterName, value) {
    const updatedFilter = cloneDeep(selectedFilterInfo);
    const selectedFilterHeading = Object.keys((updatedFilter || {}))

    const filteredData = selectedFilterHeading?.reduce((acc, curr) => {
      if (filterName === curr) {
        return { ...acc, [curr]: updatedFilter[curr]?.filter((val) => val !== value) }
      }
      else {
        return { ...acc, [curr]: updatedFilter[curr] }
      }
    }, {})
    setSelectedFilterInfo(filteredData)
  }

  function handleClearAllFilter() {
    const tempFilterOptions = filterOption?.slice(
      filterOption,
      filterOption?.length
    )
    for (let i = 0; i < tempFilterOptions?.length; i++) {
      for (let j = 0; j < tempFilterOptions[i]?.sub_filters?.length; j++) {
        if (tempFilterOptions[i].sub_filters[j]['is_selected']) {
          tempFilterOptions[i].sub_filters[j]['is_selected'] = false
        }
      }
    }
    const filterCounter = FILTER_COUNTER_OPTIONS.DEC;
    dispatch(filtersCounter(filterCounter));
    dispatch(saveFilteredOptions(tempFilterOptions));
    setSelectedFilterInfo({})
    setMB7SortAndFilterConfig({ filterAppliedCounterChanged: true });
  }

  function handleCheckboxClick(e, filterOptionName, subFilterName) {
    e?.stopPropagation?.();
    const tempFilterOptions = filterOption?.slice(
      filterOption,
      filterOption?.length
    );
    for (let i = 0; i < tempFilterOptions?.length; i++) {
      if (filterOptionName === tempFilterOptions[i]?.name) {
        for (let j = 0; j < tempFilterOptions[i]?.sub_filters?.length; j++) {
          if (subFilterName === tempFilterOptions[i].sub_filters[j]?.name) {
            if (e.target.checked) {
              setSelectedFilterInfo(prev => ({
                ...prev,
                [tempFilterOptions[i]?.name]: [...(prev[tempFilterOptions[i]?.name] || []), tempFilterOptions[i].sub_filters[j]?.name]
              }))
            }
            else {
              removeSelectedFilter(tempFilterOptions[i]?.name, tempFilterOptions[i].sub_filters[j]?.name)
            }
            e.target.checked
              ? (tempFilterOptions[i].sub_filters[j]['is_selected'] = true)
              : (tempFilterOptions[i].sub_filters[j]['is_selected'] = false);
            break;
          }
        }
      }
    }
    const filterCounter = e.target.checked
      ? FILTER_COUNTER_OPTIONS.INC
      : FILTER_COUNTER_OPTIONS.DEC;
    dispatch(filtersCounter(filterCounter));
    dispatch(saveFilteredOptions(tempFilterOptions));
    setMB7SortAndFilterConfig({ filterAppliedCounterChanged: true });
  }

  function renderSubFilters(data) {
    const subFilterData = data?.sub_filters;
    const filterName = data?.name;
    const filterId = data?.id;
    switch (filterName) {
      case COLOUR:
        return <RenderColourFilters data={subFilterData} config={pageStyle} filterName={filterName} />
      case SIZE:
        return <RenderSizeFilters data={subFilterData} config={pageStyle} filterName={filterName} />
      default:
        return <CustomFilter data={subFilterData} config={pageStyle} filterName={filterName} filterId={filterId} />
    }
  }

  function renderSelectedFilter() {
    const selectedFilterHeading = Object.keys((selectedFilterInfo || {}))
    const eventDetails = {
      target: {
        checked: false
      }
    }
    return selectedFilterHeading?.length > 0 && (
      <div className={`tw-flex tw-items-center ${desktopLayout === COMMON_LAYOUT_TYPE.TWO ? 'tw-gap-[12px]' : 'tw-gap-[8px]'} tw-flex-wrap`}>
        {
          selectedFilterHeading?.map((heading) => {
            const filterOption = selectedFilterInfo?.[heading] || [];
            return filterOption?.map((subFilterHeading, index) => (
              <div style={{ ...globalRadius }} className="tw-flex tw-items-center tw-gap-[8px] tw-px-[12px] tw-py-[8px] tw-border tw-border-solid tw-border-[#111C361F]" key={subFilterHeading + index}>
                <div className=" tw-text-[13px] tw-font-normal tw-opacity-70 tw-text-newBlack ">{`${heading}: ${subFilterHeading}`}</div>
                <div className="tw-cursor-pointer" onClick={() => handleCheckboxClick(eventDetails, heading, subFilterHeading)}>{crossSvg()}</div>
              </div>
            ))
          })
        }
      </div>
    )
  }

  function sortAndFilterContent(layoutType) {
    return (
      <div className={`tw-sticky tw-top-[75px] ${((isLayout3 || isLayout2)) ? 'tw-w-[100%]' : !isMobile ? 'tw-w-[25%]' : ''} ${isMobile ? 'tw-w-[100%]' : 'tw-min-w-[300px]'}
      tw-flex tw-flex-col tw-gap-[24px] ${!isLayout2 ? 'tw-px-[40px]' : 'tw-mb-[16px]'} ${isMobile ? '!tw-px-[16px]' : ''}`}>
        <div className={`${isLayout2 ? 'tw-flex tw-items-start tw-gap-[12px]' : ''}`}>
          {isLayout2 && <div className="tw-py-[5px]" style={{ ...getFilterTitleStyle(pageStyle, isMobile) }}>{'Filter by:'}</div>}
          <div>
            {!isLayout2 && <div className={`tw-flex tw-items-center tw-justify-between ${(isLayout3 || isMobile) ? 'tw-mt-[20px]' : ''} `}>
              <div style={{ ...getFilterStyle() }} className="tw-text-[20px] tw-leading-[36px] ">{'Filters'}</div>
              <div className="tw-flex tw-items-center tw-gap-[8px]">
                {showClearAll() && <div onClick={() => handleClearAllFilter()} className="tw-flex tw-items-center tw-opacity-70 tw-gap-[4px] tw-cursor-pointer">
                  <div>{crossSvg()}</div>
                  <div className="tw-text-[13px] tw-font-normal tw-text-newBlack tw-underline">{'Clear all filters'}</div>
                </div>}
                {(desktopLayout !== COMMON_LAYOUT_TYPE.ONE && !isMobile) && <div onClick={() => hideFilter(false)} className="wb-sprite ic-cross-black"></div>}
              </div>
            </div>}
            {isMobile && <div style={{ margin: "20px -40px 0px -40px" }} className="tw-border tw-border-solid tw-border-[#111C3629] tw-mt-[20px]"></div>}
            <div style={{ height: isLayout3 ? '90vh' : !isLayout2 ? `calc(100vh - ${filterScrollheight}px)` : '' }}
              className={`no-scrollbar tw-flex tw-items-center tw-gap-[24px] ${isMobile ? ' !tw-h-[85.5vh]' : ''} tw-pb-[20px] ${!isLayout2 ? 'tw-flex-col tw-overflow-auto tw-pt-[24px]' : 'tw-flex-wrap'}`}>
              {(!isLayout2 && showClearAll()) && <div className={!isMobile ? "tw-mt-[20px]" : ''}>{renderSelectedFilter()}</div>}
              {
                updatedFilterOption?.length &&
                updatedFilterOption?.map((data) => {
                  return data?.sub_filters?.length > 0 && (
                    <Accordian styleComp={pageStyle} key={data?.name} selectedFilterInfo={selectedFilterInfo} text={data?.name} layoutType={layoutType} selectedElement={selectedElement} handleElementClick={(id) => handleElementClick(id)}>
                      {renderSubFilters(data)}
                    </Accordian>
                  )
                })
              }
              {(isLayout2 && filterOption?.length > 5) && <div style={{ ...getFilterTitleStyle(pageStyle, isMobile) }} onClick={handleViewMoreClick} className=" !tw-font-bold tw-cursor-pointer">{!isViewMore ? '+ View more' : '- View less'}</div>}
            </div>
            <div className="tw-flex tw-items-center tw-gap-[12px]">
              {(isLayout2 && showClearAll()) && renderSelectedFilter()}
              {(showClearAll() && isLayout2) && <div onClick={() => handleClearAllFilter()} className="tw-flex tw-items-center tw-gap-[4px] tw-opacity-70  tw-cursor-pointer">
                <div>{crossSvg()}</div>
                <div className="tw-text-[13px] tw-font-normal tw-text-newBlack tw-underline">{'Clear all filters'}</div>
              </div>}
            </div>
          </div>
        </div>
      </div>
    )
  }

  function renderAccordingToLayout() {
    if (!isMobile) {
      switch (desktopLayout) {
        case COMMON_LAYOUT_TYPE.ONE:
          return <div className={`tw-flex tw-flex-col tw-gap-[24px] tw-max-w-[300px] tw-sticky tw-top-[75px]`}>{sortAndFilterContent(desktopLayout)}</div>
        case COMMON_LAYOUT_TYPE.TWO:
          return sortAndFilterContent(desktopLayout)
        case COMMON_LAYOUT_TYPE.THREE:
          return (
            <Drawer
              className="tw-z-[600] tw-select-none"
              open={showFilters}
              onClose={() => hideFilter(false)}
              sx={{
                '& .MuiDrawer-paper': {
                  width: '35%',
                },
              }}
            >
              {sortAndFilterContent(desktopLayout)}
            </Drawer>
          )
      }
    }
    else {
      return <div className="tw-flex tw-flex-col tw-gap-[24px] tw-w-[100%]">{sortAndFilterContent(desktopLayout)}</div>

    }
  }

  return (
    <>
      {filterOption?.length ? <SortAndFilterContent.Provider value={{ handleCheckboxClick, pageStyle }}>
        {renderAccordingToLayout()}
      </SortAndFilterContent.Provider> : null}
    </>
  )
}

export default SortAndFilter